var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-requested-message',_vm._g({attrs:{"message":_vm.message}},_vm.$listeners)),_vm._v(" "),(_vm.showApproval)?_c('agent-flow-user-approval',{staticClass:"gl-mt-3"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }